module.exports = __webpack_public_path__ + "img/SSLSeal.6b888e00.gif";